export default "__VITE_ASSET__CSjqU_p2__"